import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  RapidAssociationQuestionModelTypes,
  IRapidAssociationQuestionModelState,
  IRapidAssociationResponseValidation,
  IRapidAssociationQuestionSchema,
  RapidAssociationSpecialOptions
} from './types'

const RapidAssociationQuestionModel: IQuestionModelConstructor<RapidAssociationQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const text = questionSchema.text
  const pauseRegex = new RegExp(/\[\[pause_\d+]]/i)
  const keyOff = '[[keyoff]]'
  const keyOnly = '[[keyonly]]'
  const animationOff = '[[no-animation]]'
  const imagesText = '[[images-text]]'
  const options: RapidAssociationSpecialOptions = {}

  const indexKeyOff = text.indexOf(keyOff)
  const indexKeyOnly = text.indexOf(keyOnly)
  if (indexKeyOnly !== -1 || indexKeyOff !== -1) {
    if (indexKeyOnly > indexKeyOff) {
      options.keyOnly = true
    } else {
      options.keyOff = true
    }
  }
  if (text.match(pauseRegex) && text.match(pauseRegex)[0]) {
    options.pauseClick = parseInt(text.match(pauseRegex)[0].replace('[[pause_', '').replace(']]', ''), 10)
  }
  if (text.includes(animationOff)) {
    options.animationOff = true
  }
  if (text.includes(imagesText)) {
    options.imagesText = true
  }

  const updatedQuestionSchema: IRapidAssociationQuestionSchema = { ...options, ...questionSchema }
  const { model } = BaseQuestionModel<RapidAssociationQuestionModelTypes, IRapidAssociationQuestionModelState>({
    questionType: QuestionType.RAPID_ASSOCIATION,
    questionSchema: updatedQuestionSchema,
    action,
    submitResponse,
    initState,
    validateResponse,
    namedFrames: questionSchema.training ? ['training', 'question'] : ['question']
  })
  return model
}

/* eslint-disable @typescript-eslint/no-unsafe-call*/
function submitResponse({ response }: IRapidAssociationQuestionModelState) {
  const answers = response.answers ? [...response.answers] : []

  return response.training_shown ? [...answers, { training_shown: response.training_shown }] : [...answers]
}

function initState(state: IRapidAssociationQuestionModelState): IRapidAssociationQuestionModelState {
  state.response = {}
  return state
}

function validateResponse({
  response,
  frame,
  questionSchema
}: IRapidAssociationQuestionModelState): IRapidAssociationResponseValidation {
  if (!questionSchema.answers.length)
    return {
      valid: true
    }

  return {
    valid:
      'training' == frame && questionSchema.training
        ? Boolean(response?.training_shown)
        : Boolean(questionSchema.answers_mask.length == response?.answers?.length)
  }
}

export default RapidAssociationQuestionModel
